<template>
    <div class="about-crossprom">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="content-xs">
                        <SectionHeader
                            title="What 370+ Campaigners Love About CrossProm"
                            desc="From registering your campaign to setting up your first promotion collaboration, CrossProm is a one-stop-shop with everything you need for your cross-promotion marketing."/>
                        <div>
                        <swiper v-view="viewHandler" ref="mySwiper" class="swiper about-crossprom" :options="swiperOption">
                            <swiper-slide 
                                v-for="(item,index) in aboutCPdata" 
                                :key="item.desc"
                                :id="`slider-info-components-landing-${index}`">
                                    <div data-name="slider-item">
                                        <Icon :icon="item.icon"/>
                                        <div>
                                            <p>
                                                {{item.desc}}
                                            </p>
                                        </div>
                                    </div>
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                        </swiper>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
import SectionHeader from '../SectionHeader'
import { aboutCPdata } from '../landingPageData'
import initSwiperOptions from '../swiper.options'
import { computed } from '@vue/composition-api'
export default {
    name: 'AboutCrossprom',
    components: {
        SectionHeader,
        Icon
    },
    setup: function(props, context) {
        const pagination = {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        }
        const slidesPerView = 1
        const breakpoints = false
        const { swiperOption } = initSwiperOptions(slidesPerView, breakpoints, pagination)
        const swiperRef = computed(() => context.refs.mySwiper.swiper)
        const viewHandler = () => {
            swiperRef.value.slideTo(0, 1000, false)
        }
        return {
            aboutCPdata,
            swiperOption,
            viewHandler
        }
    } 
}
</script>

<style lang="scss" scoped>
$mob_desc: 18px;
$mob_lineheight: 28px;
$mob_distance: 24px;
$mob_padding: 50px 20px 40px 20px;
$mob_img: 86px;
$mob_slider_minHeight: 300px;

.about-crossprom {
    padding-top: 113px;
    padding-bottom: 103px;

    div[data-name="slider-item"] {
        width: 100%;
        border-radius: 50px;
        background: #F8F8FF;
        padding: 132px 120px 116px 120px;
        text-align: center;
        min-height: 524px;
        img {
            width: 128px;
        }
        div {
            max-width: 678px;
            margin: 0 auto;
            p {
                font-size: 27px;
                line-height: 40px;
                margin-top: 48px;
            }
        }
    }
}
@media (max-width: 767px) {
    div.about-crossprom {
        padding-top: 48px !important;
        padding-bottom: 56px;
        div[data-name="slider-item"] {
            width: 100%;
            border-radius: 50px;
            background: #F8F8FF;
            padding: $mob_padding;
            text-align: center;
            min-height: $mob_slider_minHeight;
            img {
                width: $mob_img;
            }
            p {
                font-size: $mob_desc;
                line-height: $mob_lineheight;
                margin-top: $mob_distance;
            }
        }
    }
}
</style>